import { render, staticRenderFns } from "./MainImgViewerPop.vue?vue&type=template&id=21bf6794&"
import script from "./MainImgViewerPop.vue?vue&type=script&lang=ts&"
export * from "./MainImgViewerPop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports